import * as React from 'react';

import styles from './index.module.css';

import { FormatOption, formatString } from '../utils';

interface Props {
  listItems: string[];
}

interface State {}

export class List extends React.Component<Props, State> {
  render() {
    const { listItems } = this.props;
    const hasBulletPoints = !!listItems?.length;

    return (
      <div>
        {hasBulletPoints && (
          <div className={styles.UlContainer}>
            <ul>
              {listItems?.map((item, index) => (
                <li key={index} className={styles.ListItem}>
                  {formatString(item, [
                    FormatOption.UnnumberedList,
                    FormatOption.Alert,
                    FormatOption.Info,
                  ])}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}
